export default __webpack_public_path__ + "static/hero-img-3ea479c8a8a3c90e4156d509bacc965f.png";